/*eslint no-shadow: ["off"]*/
/*eslint no-unused-vars: ["off"]*/
/*eslint-env es6*/
"use strict";

import angular from "angular";
import ngAnimate from "angular-animate";
import ngCookies from "angular-cookies";
import ngResource from "angular-resource";
import ngSanitize from "angular-sanitize";
import gettextCatalog from "angular-gettext";
import localStorageService from "angular-local-storage";
import matchMedia from "angular-media-queries";
import "isteven-angular-multiselect/isteven-multi-select.js";

import "cookieconsent/build/cookieconsent.min.js";
import "cookieconsent/build/cookieconsent.min.css";

import "angular-upload";
import "angular-socket-io";

import uiRouter from "angular-ui-router";
import uiBootstrap from "angular-ui-bootstrap";
import "angular-validation-match";

import { routeConfig } from "./app.config";

import _Auth from "../components/auth/auth.module";
import account from "./account";
import permission from "./permission";
import arrow from "./permission/permission.service";
import admin from "./admin";
import author from "./author";
import directDrMemberAuthors from "./direct-dr-member-authors";
import navbar from "../components/navbar/navbar.component";
import footer from "../components/footer/footer.component";
import main from "./main/main.component";
import files from "./files/files.component";
import constants from "./app.constants";
import util from "../components/util/util.module";
import socket from "../components/socket/socket.service";
import language from "../components/language/language.module";
import pass from "./account/password.service";
import ElasticAPI from "../components/elastic/elastic.service";
import Modal from "../components/modal/modal.service";
import wanted from "./wanted";

import "./app.scss";
import "isteven-angular-multiselect/isteven-multi-select.css";

angular
  .module("dalApp", [
    ngAnimate,
    ngCookies,
    ngResource,
    ngSanitize,
    "btford.socket-io",
    uiRouter,
    uiBootstrap,
    _Auth,
    account,
    admin,
    author,
    directDrMemberAuthors,
    permission,
    arrow,
    "validation.match",
    navbar,
    footer,
    main,
    constants,
    socket,
    util,
    gettextCatalog,
    localStorageService,
    language,
    ElasticAPI,
    Modal,
    "matchMedia",
    "lr.upload",
    "isteven-multi-select",
    pass,
    files,
    wanted,
  ])
  .config(routeConfig)
  .run(function (
    $rootScope,
    $location,
    Auth,
    gettextCatalog,
    $http,
    LanguageService
  ) {
    "ngInject";

    // Redirect to login if route requires auth and you're not logged in
    gettextCatalog.debug = true; //display [MISSING] in front of every missing translation
    gettextCatalog.debugPrefix = "[A traduire] ";

    $http({
      method: "GET",
      url: "assets/translations/template.json",
      cache: gettextCatalog.cache,
      transformResponse(json) {
        return JSON.parse(json);
      },
    }).then(function (results) {
      var data = results.data || {};
      for (var l in data) {
        if (data.hasOwnProperty(l)) {
          gettextCatalog.setStrings(l, data[l]);
        }
      }

      LanguageService.init();
      let dismissText;
      let linkText;
      let message;
      if (LanguageService.lang == "fr") {
        dismissText = "J'ai compris";
        linkText = "En savoir plus";
        message =
          "Notre site internet utilise des cookies, afin d'améliorer votre expérience lorsque vous naviguez sur notre site.";
      } else {
        dismissText = "Got it!";
        linkText = "Learn more";
        message =
          "This website uses cookies to ensure you get the best experience on our website.";
      }

      window.cookieconsent.initialise({
        cookie: {
          expiryDays: 365,
        },
        palette: {
          popup: {
            background: "#343c66",
          },
          button: {
            background: "#be0f38",
          },
        },
        theme: "classic",
        position: "bottom-right",
        content: {
          dismiss: dismissText,
          link: linkText,
          message,
          href: "/legal",
        },
        blacklistPage: ["/wanted", "/direct-dr-member-authors"],
      });
    });

    $rootScope.$on("$stateChangeStart", function (event, next) {
      Auth.isLoggedIn(function (loggedIn) {
        if (next.authenticate && !loggedIn) {
          $location.path("/main");
        }
      });
    });
  });

angular.element(document).ready(() => {
  angular.bootstrap(document, ["dalApp"], {
    strictDi: true,
  });
});



// WEBPACK FOOTER //
// ./client/app/app.js